import { useState } from 'react';
import { CurrentUser } from '../entities/Login/CurrentUser.ts';
import { redirectTo } from '../helpers/redirectTo.ts';

function getReturnUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get('returnUrl');
    return returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//') ? returnUrl : null;
}

// What happens once someone is signed in: pick a clinic when they work in several, then go to their dashboard.
export function useCompleteSignIn() {
    const [pendingUser, setPendingUser] = useState<CurrentUser | null>(null);

    const completeSignIn = (user: CurrentUser) => {
        const facilities = user.healthcareFacilities;
        if (facilities && facilities.length > 1) {
            setPendingUser(user);
            return;
        }
        if (facilities && facilities.length === 1) {
            user.selectedHealthcareFacilityID = facilities[0].id;
            localStorage.setItem('currentUser', JSON.stringify(user));
        }
        redirectTo(getReturnUrl() || user.redirect);
    };

    const selectClinic = (facilityId: number) => {
        if (!pendingUser) return;
        pendingUser.selectedHealthcareFacilityID = facilityId;
        localStorage.setItem('currentUser', JSON.stringify(pendingUser));
        redirectTo(getReturnUrl() || pendingUser.redirect);
    };

    return { pendingUser, completeSignIn, selectClinic };
}
